import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';

import { tenantProvisioningService } from '@/services/control/tenant-provisioning-service';
import type {
  ProvisionTenantInput,
  ProvisionedTenant,
} from '@/types/control/tenant-provisioning';

import { adminMutationKeys, adminQueryKeys } from '@/hooks/admin/query-keys';

/**
 * Create a tenant (HYD-2113).
 *
 * Nothing is polled afterwards: control-api awaits the mesh bootstrap before
 * answering, so the response is the truth and `mesh.status` says whether the
 * tenant is usable. The tenant list the other admin pages share gains a row.
 */
export function useProvisionTenant(): UseMutationResult<
  ProvisionedTenant,
  Error,
  ProvisionTenantInput
> {
  const queryClient = useQueryClient();

  return useMutation<ProvisionedTenant, Error, ProvisionTenantInput>({
    mutationKey: adminMutationKeys.provisionTenant(),
    mutationFn: (input) => tenantProvisioningService.create(input),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: adminQueryKeys.tenants() }),
  });
}
